import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    available: [...construction.available.lattice],
    info: construction.info.lattice,
    loaded: construction.parameters_loaded,
    selected: construction.selected.lattice
  })
);
